import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guards-grid',
  templateUrl: './guards-grid.component.html',
  styleUrls: ['./guards-grid.component.css']
})
export class GuardsGridComponent implements OnInit {
  title="Guards";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/guards/guards-grid/guards-grid.component.ts